import type { ReceiptTemplate } from '../schema';

export const safewayTemplate: ReceiptTemplate = {
  id: 'safeway',
  name: 'Safeway Receipt',
  brand: 'SAFEWAY',
  description: 'Safeway grocery store receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'safeway-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/safeway.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 20,
        addressLines: [
          'STORE #2891',
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
          '(510) 555-0127',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'safeway-trans',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: '01/04/2026 2:45 PM\nCASHIER: MIKE W.',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'safeway-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'MILK 2% GALLON', quantity: '1', price: '4.99', sku: '' },
          { id: '2', name: 'BREAD WHEAT', quantity: '1', price: '3.49', sku: '' },
          { id: '3', name: 'EGGS LARGE DZ', quantity: '1', price: '5.99', sku: '' },
          { id: '4', name: 'BANANAS', quantity: '1', price: '1.29', sku: '' },
          { id: '5', name: 'CHICKEN BREAST', quantity: '1', price: '8.99', sku: '' },
        ],
        showQuantity: true,
        showSku: false,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'safeway-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '24.75', isBold: false, isLarge: false },
          { id: 'club', label: 'CLUB CARD SAVINGS', value: '-1.50', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '0.47', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '23.72', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'safeway-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'VISA ****4144',
        fields: [],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'safeway-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'CLUB CARD MEMBER\nYOU SAVED $1.50!\n\nTHANK YOU FOR SHOPPING',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

